import { Injectable, Injector, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class validationmethod implements OnInit {
  whiteSpaceErrorMsg = "should not contain any white spaces";
  requiredErrorMsg = "is required";
  FormValid: UntypedFormGroup;
  INT11_value = 2147483647;
  waterAndOtherCharges_Max=999999.99
  Decimal_max = 99999999.99;
  Amount = 99999.99;
  DeductionType = "Rent"
  twoDecimalPattern = /^[0-9]+(?:\.[0-9]+)?$/
  PASSWORDPATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~!@#\$%\^&\*()_+=[\]{}|\\,.?:"';<>/ -])(?=.{8,})(?=[a-zA-Z0-9~!@#$%^&*()_+=[\]{}|\\,.?:"';<>/ -]*$)(?!.*[ ])/
  Approved_status = "Approved";
  constructor(private snackbar: MatSnackBar) {

  }
  ngOnInit() {

  }
  //Validating all form fields
  validateAllFormFields(formGroup: UntypedFormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof UntypedFormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  //validation checking type 1
  getFormValidationErrors() {
    Object.keys(this.FormValid.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.FormValid.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {

        });
      }
    });
  }

  getvalidationmessage() {
    this.snackbar.open("All mandatory fields to be filled ", "OK", {
      duration: 5000,
    });
  }

  public noWhitespaceValidator(control: UntypedFormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  equalto(field_name): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

      let input = control.value;

      let isValid = control.root.value[field_name] == input
      if (!isValid)
        return { 'equalto': { isValid } }
      else
        return null;
    };
  }

  /**
   * Modified by Manit Kumar
   * Date: 26-07-2024
   * Adding method to validate the Special Characters
   */
  public specialCharacterValidator(control: UntypedFormControl) {
    const forbiddenChars = /[<>()'"/\\*;:=\{\}`%+\^!]/;
    const hasForbiddenChars = forbiddenChars.test(control.value);
    return hasForbiddenChars ? { 'specialCharacter': true } : null;
 }
}
